import React from 'react';

import * as recurrence from '../../../../constants/recurrence-constants';

import IntervalChoice from '../single-form-choices/interval-choice';
import WeekdayChoice from '../single-form-choices/weekday-choice';

import ChoiceGroup from '../form-wrappers/choice-group';

const WeeklyGroup = ({ onChangeGroup, requiredItems, selectedChoice, isRadioGroup, rootContainer }) => {
  const simpleChoiceSizes = { span: 24, offset: 0, prefix: { span: 10, offset: 0 }, child: { span: 10, offset: 0 }, suffix: { span: 4, offset: 0 } };
  return (
    <ChoiceGroup
      itemObj={{
        isRadioGroup: isRadioGroup,
        onChange: onChangeGroup,
      }}
    >
      <IntervalChoice
        suffix={'week(s)'}
        choiceObj={{
          choiceLineValue: 'interval',
          selectedChoice: selectedChoice,
          requiredItems: requiredItems,
          isRadioGroup: isRadioGroup,
          sizes: simpleChoiceSizes,
        }}
      />

      <WeekdayChoice
        choiceObj={{
          choiceLineValue: 'byDay',
          selectedChoice: selectedChoice,
          requiredItems: requiredItems,
          isRadioGroup: isRadioGroup,
          sizes: simpleChoiceSizes,
          inputType: recurrence.INPUT_TYPES.MULTI_SELECT,
        }}
        rootContainer={rootContainer}
      />
    </ChoiceGroup>
  );
};
export default WeeklyGroup;
